export const messages = (state) => state.waitingList.messages;
export const list = (state) => state.waitingList.list;
export const loading = (state) => state.waitingList.loading;
